import groupBy from 'lodash/groupBy';
import values from 'lodash/values';
import _get from 'lodash/get';
import differenceWith from 'lodash/differenceWith';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import flatten from 'lodash/flatten';
import uniqBy from 'lodash/uniqBy';
import filter from 'lodash/filter';
import isUndefined from 'lodash/isUndefined';

import { change, SubmissionError, getFormValues, getFormInitialValues } from 'redux-form';
import http from '../../../../../shared/http';
import endpoints from '../../../../../../config/endpoints';
import { createSelectOptionsFromSysEnums } from '../../../../../shared/form-elements/select';
import { getFiltersObject } from '../../../../../shared/filters';
import { getTargetValues } from '../../../../../programs/components/forms/targeting';
import { actions as rootActions } from '../../../../../root';
import { actions as parentActions } from '../../../../../affiliates/profile';
import qs from 'qs';

const defaultInitialState = {
	listOfActivePanIndex: [],
	selectedCurrenciesPanIndexMap: {},
	offerDefaultTargets: {},
	offerTargetsForHighlight: {},
	nullifiedBoosts: [],
	isCommentFormVisible: false,
	isSubmitDisabled: false,
	field: {
		location_id: null,
		currency: null,
		amount: null,
		status: 'active'
	}
};

const createIndividualTermsForm = ({ namespace, stateNodeName }) => {
	// action types
	const TERMS_FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const TERMS_FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	const FETCH_SUGGEST_SUCCESS = `${namespace}/fetch-suggest-success`;
	const FETCH_SUGGEST_ERROR = `${namespace}/fetch-suggest-error`;

	const SHOW_TARGETS = `${namespace}/${stateNodeName}-show-targets`;
	const HIDE_TARGETS = `${namespace}/${stateNodeName}-hide-targets`;

	const SHOW_SUBMIT = `${namespace}/${stateNodeName}-show-submit`;
	const HIDE_SUBMIT = `${namespace}/${stateNodeName}-hide-submit`;

	const DELETE_CAMPAIGN_PAYOUTS_SUCCESS = `${namespace}/${stateNodeName}-DELETE_CAMPAIGN_PAYOUTS_SUCCESS`;
	const DELETE_CAMPAIGN_PAYOUTS_ERR = `${namespace}/${stateNodeName}-DELETE_CAMPAIGN_PAYOUTS_ERR`;

	const FETCH_OFFER_DEFAULT_TARGET_SUCCESS = `${namespace}/${stateNodeName}-fetch-offer-default-target-success`;
	const FETCH_OFFER_DEFAULT_TARGET_ERRROR = `${namespace}/${stateNodeName}-fetch-offer-default-target-error`;

	const COMMENT_FORM_STORE_IMAGE = `${namespace}/${stateNodeName}-comment-form-store-image`;

	const CHANGE_CURRENCY = `${namespace}/${stateNodeName}-change-currency`;

	const TOGGLE_COMMENT_FORM = `${namespace}/${stateNodeName}-toggle-comment-form`;

	const OFFER_ACCESS_SUCCESS = `${namespace}/${stateNodeName}-offer-access-success`;
	const OFFER_ACCESS_ERROR = `${namespace}/${stateNodeName}-offer-access-error`;

	const TERMS_DELETE_SUCCESS = `${namespace}/${stateNodeName}-delete-success`;
	const TERMS_DELETE_ERROR = `${namespace}/${stateNodeName}-delete-error`;

	const OFFER_DELETE_SUCCESS = `${namespace}/${stateNodeName}-offer-delete-success`;
	const OFFER_DELETE_ERROR = `${namespace}/${stateNodeName}-offer-delete-error`;

	const FETCH_DEFAULT_TARGET_FOR_REMOVE = `${namespace}/${stateNodeName}-fetch-default-target-for-remove`;
	const FETCH_DEFAULT_TARGET_FOR_REMOVE_ERROR = `${namespace}/${stateNodeName}-fetch-default-target-for-remove-error`;

	const SET_OFFER_TARGETS_FOR_HIGHLIGHT = `${namespace}/${stateNodeName}-set-offer-targets-for-highlight`;
	const NULLIFY_BOOST = `${namespace}/${stateNodeName}-nullify-boost`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		prepareTermsFormSubmit: (formData) => (dispatch, getState) => {
			return actions.termsFormSubmit(formData)(dispatch, getState);
		},
		toggleCommentForm: () => ({
			type: TOGGLE_COMMENT_FORM
		}),
		getCampaignData: (presentCampaigns, offerId) => (dispatch, getState) => {
			const campaign_id = window.prompt('Enter campaign_id to add payout to it');
			if (!campaign_id) {
				return Promise.reject();
			}
			if (presentCampaigns.some(cmp => cmp.campaign_id == campaign_id)) {
				alert('Campaign is already added');
				return Promise.reject();
			}
			const affiliate_id = getState().affiliateProfile.affiliateId;
			return http({
				url: `${endpoints.CAMPAIGNS.PAYOUTS_LOOKUP}?${qs.stringify({
					filters: {campaign_id: [campaign_id]},
					affiliate_id,
					offer_id: offerId
				})}`,
				method: 'get',
				actions: ['FETCH_CAMPAIGN_BY_ID_OK', 'FETCH_CAMPAIGN_BY_ID_FAIL']
			})(dispatch)
				.then(result => {
					if (result.type === 'FETCH_CAMPAIGN_BY_ID_OK') {
						return _get(result, 'payload.data.0');
					} else {
						alert(result.payload.response.data.message);
						throw new Error();
					}
				});
		},
		termsFormSubmit: (formData) => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;
			const affiliateIndividualTermsForm = getFormValues('affiliateIndividualTermsForm')(getState());
			const needSubmitCampPayouts = selectors.getIsNeedToUpdateCampaignPayouts(getState());

			const offersIdsToApprove = getOffersIdsToApprove(formData.terms, getState());
			const individualTerms = getOffersIndividualTerms(formData.terms, getState(), offersIdsToApprove);
			if (!(offersIdsToApprove.length > 0 || individualTerms.length > 0) && !needSubmitCampPayouts)
				return;

			return dispatch(actions.offersAccess(offersIdsToApprove)).then(action => {
				if (action && action.type === OFFER_ACCESS_SUCCESS) {
					dispatch(parentActions.toggleProgressBar());
					dispatch(parentActions.fetchOffers(affiliateId));
				}

				if (individualTerms && individualTerms.length) {
					return dispatch(actions.offersPutIndividualTerms(individualTerms))
						.then(async action => {
							if (action.type === TERMS_FORM_SUBMIT_SUCCESS) {
								dispatch(parentActions.toggleProgressBar());
								dispatch(parentActions.fetchOffers(affiliateId));
							}
							if (needSubmitCampPayouts) {

								await actions.updateCampaignPayouts(affiliateIndividualTermsForm)(dispatch, getState);
							}

							if (action.type === TERMS_FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
								// child payouts should not be higher than masters:
								// tmp solution until submission error mapping gets improved
								let isChildAffiliateError =
									action.payload.response.data &&
									action.payload.response.data
										.filter(e => e.message === `can't setup these payouts for child account`)
										.length;

								if (isChildAffiliateError) {
									alert(`child payouts should not be higher than masters`);
									return;
								}

								const validationsErrors = prepareValidationError(formData);
								throw new SubmissionError({
									terms: validationsErrors
								});
							}
						});
				}
				if (needSubmitCampPayouts) {
					return actions.updateCampaignPayouts(affiliateIndividualTermsForm)(dispatch, getState);
				}
			});
		},

		offersAccess: offersIds => (dispatch, getState) => {
			if (isEmpty(offersIds)) return Promise.resolve();

			const { affiliateId } = getState().affiliateProfile;
			const requestUrls = offersIds.map(id => endpoints.OFFERS.GRAND_ACCESS.replace('{id}', id));

			const request = http({
				url: requestUrls,
				method: 'put',
				actions: [OFFER_ACCESS_SUCCESS, OFFER_ACCESS_ERROR],
				data: {
					affiliate_id: affiliateId
				}
			});

			return request(dispatch);
		},
		updateCampaignPayouts: (formData) => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;

			const request = http({
				url: endpoints.CAMPAIGNS.PAYOUTS,
				method: 'put',
				actions: ['UPDATE_CAMPAIGN_PAYOUTS_SUCCESS', 'UPDATE_CAMPAIGN_PAYOUTS_ERROR'],
				data: prepareCampaignPayoutsSubmit(formData, getState())
			});
			request(dispatch).then(() => dispatch(parentActions.fetchData({params: {id: affiliateId}})));
		},
		offersPutIndividualTerms: (prepareData) => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;
			const urls = prepareData.map(
				entity => `${endpoints.OFFERS.INDIVIDUAL_TERMS.replace('{id}', entity.offer)}/${affiliateId}`
			);
			const data = prepareData.map(entity => entity.fields);
			const offer_ids = prepareData.map(entity => entity.offer);

			const request = http({
				url: urls,
				method: 'put',
				actions: [TERMS_FORM_SUBMIT_SUCCESS, TERMS_FORM_SUBMIT_ERROR],
				data: data
			});

			return dispatch(actions.offersAccess(offer_ids)).then(action => {
				if (action.type === OFFER_ACCESS_SUCCESS) {
					return request(dispatch);
				}
				return action;
			});
		},

		removeCampaignPayout: params => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;

			return http({
				url: `${endpoints.CAMPAIGNS.PAYOUTS}/${params.campaign_id}`,
				method: 'delete',
				actions: [DELETE_CAMPAIGN_PAYOUTS_SUCCESS, DELETE_CAMPAIGN_PAYOUTS_ERR]
			})(dispatch)
				.then(() => dispatch(parentActions.fetchData({params: {id: affiliateId}})));
		},
		offersLookups: text => (dispatch, getState) => {
			const { offers, individualTermsFilters } = getState().affiliateProfile;

			const filters = getFiltersObject(individualTermsFilters);

			const request = http({
				url: `${endpoints.LOOKUPS.OFFERS}?${qs.stringify({ query: text, countries: filters.country_ids })}`,
				method: 'get',
				actions: [FETCH_SUGGEST_SUCCESS, FETCH_SUGGEST_ERROR]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					const filtered = action.payload.data.filter(entity => {
						return !find(offers, savedOffers => savedOffers.id === entity.id);
					});
					return {
						options: createSelectOptionsFromSysEnums(filtered)
					};
				}
			});
		},

		termsShowTargets: index => ({
			type: SHOW_TARGETS,
			payload: index
		}),

		termsHideTargets: index => ({
			type: HIDE_TARGETS,
			payload: index
		}),

		fetchOfferDefaultTarget: (index, offer, shouldAppendToIndividualTerms = false) => (dispatch, getState) => {
			if (!offer) return null;
			let data = find(getState().affiliateProfile.offers, { id: offer.value });
			if (!data) {
				dispatch(rootActions.spinnerToggle());

				const request = http({
					url: endpoints.OFFERS.TARGETING.replace('{id}', offer.value),
					method: 'get',
					actions: [FETCH_OFFER_DEFAULT_TARGET_SUCCESS, FETCH_OFFER_DEFAULT_TARGET_ERRROR],
					addToResponse: {
						index,
						offer,
						shouldAppendToIndividualTerms
					}
				});

				request(dispatch).then(action => {
					if (action.type === FETCH_OFFER_DEFAULT_TARGET_SUCCESS) {
						const { payload: { data } } = action;
						toggleFormOfferTargeting(data, shouldAppendToIndividualTerms, dispatch, index, offer, actions);
					}
				});
			} else {
				dispatch(rootActions.spinnerToggle());
				data = data.base_payouts || [];
				data = data.map(entity => {
					entity['offer_id'] = offer.value;
					return entity;
				});
				toggleFormOfferTargeting(data, shouldAppendToIndividualTerms, dispatch, index, offer, actions);
			}
		},

		changeIndTermCurrency: (index, currency) => ({
			type: CHANGE_CURRENCY,
			payload: {
				index,
				currency
			}
		}),

		deleteOffers: offerId => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;

			dispatch(parentActions.toggleProgressBar());

			const request = http({
				url: endpoints.OFFERS.REVOKE_ACCESS.replace('{id}', offerId),
				method: 'put',
				actions: [OFFER_DELETE_SUCCESS, OFFER_DELETE_ERROR],
				data: {
					affiliate_id: affiliateId
				}
			});

			dispatch(request).then(action => {
				if (action.type === OFFER_DELETE_SUCCESS) {
					dispatch(parentActions.fetchOffers(affiliateId));
				}
			});
		},

		termsResetToDefault: (offerId, locationId) => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;

			const request = (offerId, affiliateId, defaultTerms) => {
				const request = http({
					url: `${endpoints.OFFERS.INDIVIDUAL_TERMS.replace('{id}', offerId)}/${affiliateId}`,
					method: 'put',
					actions: [TERMS_FORM_SUBMIT_SUCCESS, TERMS_FORM_SUBMIT_ERROR],
					data: defaultTerms
				});

				dispatch(parentActions.toggleProgressBar());

				request(dispatch).then(action => {
					if (action.type === TERMS_FORM_SUBMIT_SUCCESS) {
						dispatch(parentActions.fetchOffers(affiliateId));
					}
				});
			};

			const defaultTargetRequest = http({
				url: endpoints.OFFERS.TARGETING.replace('{id}', offerId),
				method: 'get',
				actions: [FETCH_DEFAULT_TARGET_FOR_REMOVE, FETCH_DEFAULT_TARGET_FOR_REMOVE_ERROR]
			});

			dispatch(defaultTargetRequest).then(action => {
				if (action.type === FETCH_DEFAULT_TARGET_FOR_REMOVE) {
					const { data } = action.payload;
					const defaultTerms = data.filter(entity => entity['location_id'] === locationId);

					if (defaultTerms.length === 1 && !defaultTerms[0].amount) {
						return dispatch(actions.individualTermsDeleteRequest(offerId, locationId)).then(action => {
							dispatch({
								type: TERMS_FORM_SUBMIT_SUCCESS
							});
							dispatch(parentActions.fetchOffers(affiliateId));
						});
					}

					if (defaultTerms.length === 1 && defaultTerms[0].amount) {
						return dispatch(actions.individualTermsDeleteRequest(offerId, locationId)).then(action => {
							request(offerId, affiliateId, defaultTerms);
						});
					}

					request(offerId, affiliateId, defaultTerms);
				}
			});
		},

		individualTermsDeleteRequest: (offerId = null, locationId = null) => (dispatch, getState) => {
			const { individualTerms, affiliateId } = getState().affiliateProfile;
			const criteria = Object.assign({ offer_id: offerId }, locationId ? { location_id: locationId } : {});

			const grouped = groupBy(uniqBy(filter(individualTerms, criteria), 'location_id'), entity => entity.offer_id);

			if (isEmpty(grouped)) return Promise.resolve(true);

			const urls = grouped[offerId].map(
				entity => `${endpoints.OFFERS.INDIVIDUAL_TERMS.replace('{id}', offerId)}/${entity.location_id}/${affiliateId}`
			);

			const request = http({
				url: urls,
				method: 'delete',
				actions: [TERMS_DELETE_SUCCESS, TERMS_DELETE_ERROR]
			});

			return request(dispatch);
		},

		setOfferTargetsForHighlight: (index, targets) => ({
			type: SET_OFFER_TARGETS_FOR_HIGHLIGHT,
			payload: {
				index,
				targets
			}
		}),

		indTermsNullifyBoostOnSubmit: target => (dispatch, getState) => {

			const {isBoosted, payoutPath} = target;

			if (isBoosted) {
				const offerDefaultTargets = {
					terms: _get(getState(), 'affiliateProfile.individualTermsForm.offerTargetsForHighlight')
				};
				const defaultPrice = _get(offerDefaultTargets, payoutPath);
				dispatch(change('affiliateIndividualTermsForm', payoutPath, defaultPrice));
			}
			dispatch({
				type: NULLIFY_BOOST,
				payload: target
			});
		}
	};

	// reducers
	const reducers = {
		[SHOW_TARGETS]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				listOfActivePanIndex: [].concat(state.individualTermsForm.listOfActivePanIndex, action.payload)
			}
		}),

		[HIDE_TARGETS]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				listOfActivePanIndex: state.individualTermsForm.listOfActivePanIndex.filter(index => index !== action.payload)
			}
		}),

		[SHOW_SUBMIT]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				isSubmitDisabled: false
			}
		}),

		[HIDE_SUBMIT]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				isSubmitDisabled: true
			}
		}),

		[FETCH_OFFER_DEFAULT_TARGET_SUCCESS]: (state, action) => {
			const { payload: { data }, meta: { index, offer, shouldAppendToIndividualTerms } } = action;
			let stateBranch = {};

			if (shouldAppendToIndividualTerms) {
				const modifyData = data.map(entity => {
					entity['offer_id'] = offer.value;
					return entity;
				});

				const individualTerms = [].concat(
					state.individualTerms,
					differenceWith(
						modifyData,
						state.individualTerms,
						(first, second) => first['offer_id'] === second['offer_id'] && first['location_id'] == second['location_id']
					)
				);

				stateBranch = {
					individualTerms
				};
			} else {
				stateBranch = {
					individualTermsForm: {
						...state.individualTermsForm,
						offerDefaultTargets: {
							...state.individualTermsForm.offerDefaultTargets,
							[index]: {
								offer,
								targets: data
							}
						}
					}
				};
			}

			return {
				...state,
				...stateBranch
			};
		},

		[CHANGE_CURRENCY]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				selectedCurrenciesPanIndexMap: {
					...state.individualTermsForm.selectedCurrenciesPanIndexMap,
					[action.payload.index]: action.payload.currency
				}
			}
		}),

		[TERMS_FORM_SUBMIT_SUCCESS]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				offerDefaultTargets: {},
				listOfActivePanIndex: []
			}
		}),

		[OFFER_ACCESS_SUCCESS]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				offerDefaultTargets: {},
				listOfActivePanIndex: []
			}
		}),

		[TOGGLE_COMMENT_FORM]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				isCommentFormVisible: !state.individualTermsForm.isCommentFormVisible
			}
		}),

		[SET_OFFER_TARGETS_FOR_HIGHLIGHT]: (state, action) => {
			const { index, targets } = action.payload;
			return {
				...state,
				individualTermsForm: {
					...state.individualTermsForm,
					offerTargetsForHighlight: {
						...state.individualTermsForm.offerTargetsForHighlight,
						[index]: {
							targets
						}
					}
				}
			};
		},
		[COMMENT_FORM_STORE_IMAGE]: (state, action) => ({
			...state,
			individualTermsForm: {...state.individualTermsForm, reason_image: action.payload}
		}),

		[NULLIFY_BOOST]: (state, action) => ({
			...state,
			individualTermsForm: {
				...state.individualTermsForm,
				// concat if not already in state
				nullifiedBoosts: find(state.individualTermsForm.nullifiedBoosts, {
					offerId: action.payload.offerId,
					locationId: action.payload.locationId
				})
					? state.individualTermsForm.nullifiedBoosts
					: state.individualTermsForm.nullifiedBoosts.concat(action.payload)
			}
		})
	};

	// selectors
	const selectors = {
		getFormData: state => {
			const {
				data,
				offers,
				individualTerms,
				individualTermsForm: {
					listOfActivePanIndex,
					offerDefaultTargets,
					selectedCurrenciesPanIndexMap,
					offerTargetsForHighlight,
					nullifiedBoosts
				}
			} = state.affiliateProfile;

			if (!offers) return [];

			const prepareSavedOffers = getPreparedSavedOffers(offers, individualTerms);

			const prepareSelectedOffers =
				offerDefaultTargets &&
				values(offerDefaultTargets).map(entity => ({
					offer: [entity.offer],
					targets: getTargetValues(entity.targets)
				}));

			const {campaignPayouts} = state.affiliateProfile.data;

			const initialValues = {
				terms: [].concat(
					prepareSavedOffers.map(offer => ({
						...offer,
						targets: offer.targets.map(trgt => ({
							...trgt,
							campaigns:
								campaignPayouts
									.filter(cp => !!cp.country_id)
									.filter(cp => !cp.sid_type)
									.filter(cp => !cp.sid)
									.filter(cp =>
										cp.country_id === _get(trgt, 'location_id.0.value') &&
										trgt.offer_id === cp.offer_id
									)
									.map(cp => {
										if (!cp[`${cp.campaign_currency}_amount`]) {
											return {
												...cp,
												[`${cp.campaign_currency}_amount`]: trgt[cp.campaign_currency]
											};
										}
										return cp;
									})
									.map(cp => {
										const campPayout = {...cp};
										if (!campPayout.rub_amount) {
											campPayout.rub_amount = trgt['rub'];
										}
										if (!campPayout.usd_amount) {
											campPayout.usd_amount = trgt['usd'];
										}
										if (!campPayout.eur_amount) {
											campPayout.eur_amount = trgt['eur'];
										}
										return campPayout;
									})

						}))
					})),
					prepareSelectedOffers || []
				)
			};
			const isMaster = data.is_master;

			return {
				initialValues,
				listOfActivePanIndex,
				selectedCurrenciesPanIndexMap,
				savedTerms: prepareSavedOffers,
				defaultTerms: offerTargetsForHighlight,
				nullifiedBoosts,
				isMaster
			};
		},
		getIsNeedToUpdateCampaignPayouts: state => {
			const affiliateIndividualTermsForm = getFormValues('affiliateIndividualTermsForm')(state);
			const affiliateIndividualTermsFormInitital =
				getFormInitialValues('affiliateIndividualTermsForm')(state);

			const submitDataBefore = prepareCampaignPayoutsSubmit(affiliateIndividualTermsForm, state);
			const submitDataAfter = prepareCampaignPayoutsSubmit(affiliateIndividualTermsFormInitital, state);

			return !_isEqual(submitDataBefore.campaign_payouts, submitDataAfter.campaign_payouts);
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

// functions
const getPreparedSavedOffers = (offers, individualTerms) =>
	offers.map(offer => {
		const groupTermsByOffer = groupBy(individualTerms, term => term.offer_id);
		return {
			hasIndividualTerms: offer.payouts && offer.payouts[0] ? !!offer.payouts[0]['is_individual_term'] : false,
			offer: [
				{
					value: offer.id,
					label: offer.title
				}
			],
			targets: getTargetValues(groupTermsByOffer[offer.id]) || []
		};
	});
const getOffersIdsToApprove = (formData, state) => {
	const { offers, individualTermsForm: { offerDefaultTargets } } = state.affiliateProfile;

	const filtered = formData.filter((entity, index) => {
		if (!entity.offer) return false;

		let filtered = false;

		const offerId = entity.offer[0].value;
		const offerTargets = entity.targets;
		const notInUserOffer = !find(offers, offer => offer.id === offerId);

		if (notInUserOffer) {
			const defaultTargets = getTargetValues(offerDefaultTargets[index]['targets']);
			const hasCustomTarget = offerTargets.filter(offerTarget => {
				return !find(defaultTargets, defaultTarget => {
					return offerTarget.rub === defaultTarget.rub && offerTarget.usd === defaultTarget.usd;
				});
			}).length;

			if (!hasCustomTarget) {
				filtered = true;
			}
		}
		return filtered;
	});

	return filtered.map(entity => entity.offer[0].value);
};

const getOffersIndividualTerms = (formData, state, toApproveOffersIds) => {
	const { offers, individualTerms, individualTermsForm } = state.affiliateProfile;
	const { offerDefaultTargets, nullifiedBoosts } = individualTermsForm;
	const currencies = state.root.lists['available-currencies'];

	const data = formData.filter(entity => {
		const hasTarget = entity.targets && entity.targets.length;
		const inToApproved = !!find(toApproveOffersIds, offerId => entity.offer[0]['value'] === offerId);
		return hasTarget && !inToApproved;
	});

	const prepareSelectedOffers =
		offerDefaultTargets &&
		values(offerDefaultTargets).map(entity => ({
			offer: [entity.offer],
			targets: getTargetValues(entity.targets)
		}));

	const prepareSavedOffers = getPreparedSavedOffers(offers, individualTerms);

	const dirtyData = getDirtyData([].concat(prepareSavedOffers, prepareSelectedOffers || []), data, nullifiedBoosts);

	if (dirtyData.length === 0) return [];

	const res = dirtyData.map(entity => {
		const fields = entity.targets.map(field => {
			const correctFields = currencies.filter(currency => !!field[currency.id]).map(currency => ({
				...individualTermsForm.field,
				...field,
				status: 'active',
				location_id: field['location_id'] && field['location_id'][0] ? field['location_id'][0]['value'] : '',
				currency: currency.id,
				amount: field[currency.id]
			}));

			return correctFields.length
				? correctFields
				: {
					...individualTermsForm.field
				};
		});

		return {
			offer: (entity.offer[0] && entity.offer[0].value) || null,
			fields: flatten(fields).filter(entity => !!entity.currency)
		};
	});

	return res.filter(entity => !isEmpty(entity.fields));
};

// return value is different from the initialized value for submit
const getDirtyData = (savedValues, formValues, nullifiedBoosts) => {
	const res = [];

	formValues.forEach(formValueEntity => {
		if (isEmpty(savedValues)) {
			res.push(formValueEntity);
		} else if (isNonInInitialValues(formValueEntity, savedValues)) {
			res.push(formValueEntity);
		} else {
			savedValues.forEach(initialValueEntity => {
				if (formValueEntity.offer[0] && formValueEntity.offer[0].value === initialValueEntity.offer[0].value) {
					const changedTargets = formValueEntity.targets
						.map(newTarget => {
							const oldTarget = find(initialValueEntity.targets, {
								location: newTarget.location,
								offer_id: newTarget.offer_id
							});
							if (!oldTarget) return true;
							return Number(newTarget.rub || 0) !== Number(oldTarget.rub || 0)
								|| Number(newTarget.usd || 0) !== Number(oldTarget.usd || 0)
								|| Number(newTarget.cap || 0) !== Number(oldTarget.cap || 0)
								|| oldTarget.is_locked !== newTarget.is_locked;
						})
						.filter(Boolean);

					const changedToNullTargetsResetToDefault = formValueEntity.targets.map(newTarget => {
						let initialTarget = find(initialValueEntity.targets, { location: newTarget.location });
						if (initialTarget) {
							let result = { ...initialTarget };

							let isChangedToNullRub = !isUndefined(initialTarget['rub']) && !newTarget['rub'];
							let isChangedToNullUsd = !isUndefined(initialTarget['usd']) && !newTarget['usd'];

							if (isChangedToNullRub || isChangedToNullUsd) {
								result.usd = isChangedToNullUsd ? initialTarget.usd : newTarget.usd;
								result.rub = isChangedToNullRub ? initialTarget.rub : newTarget.rub;
								return result;
							}
						}
						return newTarget;
					});

					const withDroppedBoosters = changedToNullTargetsResetToDefault.map(newTarget => {
						const result = { ...newTarget };
						const oldTarget = find(initialValueEntity.targets, { location: newTarget.location });
						const wasBoostNullified = !!find(nullifiedBoosts, {
							offerId: newTarget.offer_id,
							locationId: newTarget.location_id[0].value
						});

						if (wasBoostNullified && (newTarget['rub'] != oldTarget['rub'] || oldTarget['usd'] != oldTarget['usd'])) {
							result.boost_till = null;
						}
						return result;
					});

					if (changedTargets.length) {
						res.push({
							offer: formValueEntity.offer,
							targets: withDroppedBoosters
						});
					}
				}
			});
		}
	});

	return res;
};

const isNonInInitialValues = (formValueEntity, initialValues) => {
	return isEmpty(
		initialValues.filter(
			initialValueEntity =>
				formValueEntity.offer[0] && formValueEntity.offer[0].value === initialValueEntity.offer[0].value
		)
	);
};

const prepareValidationError = formData => {
	const validationsErrors = [];

	formData['terms'].forEach((field, index) => {
		validationsErrors[index] = {};

		if (!field.offer || (Array.isArray(field.offer) && !field.offer.length)) {
			validationsErrors[index]['offer'] = 'Offer should not be empty';
		}

		const validationsTargetsError = [];

		field['targets'].forEach((targetsField, targetsIndex) => {
			validationsTargetsError[targetsIndex] = {};
			if ((!targetsField.rub && !targetsField.usd) || (targetsField.rub == 0 || targetsField.usd == 0)) {
				validationsTargetsError[targetsIndex]['rub'] = 'rub or usd should be >= 0.01';
				validationsTargetsError[targetsIndex]['usd'] = 'usd or rub should be >= 0.01';
			} else {
				if (targetsField.rub && isNaN(parseFloat(targetsField.rub))) {
					validationsTargetsError[targetsIndex]['rub'] = 'rub must be number';
				}
				if (targetsField.usd && isNaN(parseFloat(targetsField.usd))) {
					validationsTargetsError[targetsIndex]['usd'] = 'usd must be number';
				}
			}
		});

		validationsErrors[index]['targets'] = validationsTargetsError;
	});

	return validationsErrors;
};

const toggleFormOfferTargeting = (data, shouldAppendToIndividualTerms, dispatch, index, offer, actions) => {
	const targets = getTargetValues(data);
	if (!shouldAppendToIndividualTerms) {
		dispatch(
			change('affiliateIndividualTermsForm', `terms[${index}]`, {
				offer: [offer],
				targets
			})
		);
	}
	dispatch(rootActions.spinnerToggle());
	dispatch(actions.setOfferTargetsForHighlight(index, targets));
	dispatch(actions.termsShowTargets(index));
};

const prepareCampaignPayoutsSubmit = (formData, state) => {
	let sendData = formData.terms
		.map(i => i.targets || [])
		.filter(targets => targets.some(trgt => Boolean(trgt.campaigns && trgt.campaigns.length)));

	let initialSendData = getFormInitialValues('affiliateIndividualTermsForm')(state).terms
		.map(i => i.targets)
		.filter(targets => targets.some(trgt => Boolean(trgt.campaigns && trgt.campaigns.length)));

	sendData = sendData.reduce((acc, value) => {
		const res = acc;
		res.push(...value);
		return res;
	}, []);

	sendData = sendData.reduce((acc, trgt) => {
		const res = acc || [];
		trgt.campaigns.forEach(
			cmp => {
				res.push({
					...cmp,
					location_id: _get(trgt, 'location_id.0.value'),
					amount: cmp[`${cmp.campaign_currency}_amount`] || null,
					currency: cmp.campaign_currency
				});
			}
		);
		return res;
	}, []);

	initialSendData = initialSendData.reduce((acc, value) => {
		const res = acc;
		res.push(...value);
		return res;
	}, []);

	initialSendData = initialSendData.reduce((acc, trgt) => {
		const res = acc || [];
		trgt.campaigns.forEach(
			cmp => {
				res.push({
					...cmp,
					location_id: _get(trgt, 'location_id.0.value'),
					amount: cmp[`${cmp.campaign_currency}_amount`] || null,
					currency: cmp.campaign_currency
				});
			}
		);
		return res;
	}, []);
	sendData = sendData.filter(sd => {
		if (!find(initialSendData, { campaign_id: sd.campaign_id, country_id: sd.country_id })) {
			return true;
		}
		const initialAmount = find(
			initialSendData, { campaign_id: sd.campaign_id, country_id: sd.country_id }
		);
		if (Number(initialAmount.amount) !== Number(sd.amount)) {
			return true;
		}
		return false;
	});
	return {
		affiliate_id: state.affiliateProfile.affiliateId,
		campaign_payouts: sendData
	};
};

export default createIndividualTermsForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/individual-terms/index.js